import React from 'react';
import { ClipboardIcon } from './ui/StockClerkLogo';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
          <div className="w-full max-w-md text-center">
            <div className="flex justify-center mb-6 text-text">
              <ClipboardIcon size={32} />
            </div>
            <h1 className="text-2xl font-bold text-text mb-2">
              Something went wrong
            </h1>
            <p className="text-text-muted mb-8">
              We've been notified and are working on a fix.
            </p>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full py-2.5 px-4 rounded-lg text-white font-semibold transition-colors"
                style={{ background: '#8B7355' }}
                onMouseOver={(e) => (e.currentTarget.style.background = '#6B5344')}
                onMouseOut={(e) => (e.currentTarget.style.background = '#8B7355')}
              >
                Refresh page
              </button>
              <a
                href="/dashboard"
                className="w-full inline-block py-2.5 px-4 rounded-lg font-semibold transition-colors border"
                style={{ color: '#8B7355', borderColor: '#E8E4DD' }}
              >
                Go to Dashboard
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
